import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ChatService {
  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {}

  // conversation: optional array of {sender, text, timestamp}
  sendMessage(sessionId: string, message: string, conversation: any[] = [], starterHint: string = ''): Observable<any> {
    return this.http.post<any>(this.apiUrl + '/chat/process', { session_id: sessionId, message, conversation, starter_hint: starterHint });
  }
}
